	


	function showAndMoveAnEleToTheClickedEle(offset_of_theClickedElement, width_of_theClickedElement, class_of_theElementToBeMoved){


		$("."+class_of_theElementToBeMoved).css("display","none");

		mouseIsInx = parseInt(offset_of_theClickedElement.left);

		mouseIsIny = parseInt(offset_of_theClickedElement.top);

		width_of_theElementToBeMoved = $("."+class_of_theElementToBeMoved).css("width");
		
		width_of_theElementToBeMoved = parseInt(width_of_theElementToBeMoved);

		left_of_theElementToBeMoved  = parseInt((mouseIsInx - width_of_theElementToBeMoved) + width_of_theClickedElement) ;

		top_of_theElementToBeMoved  = mouseIsIny+height_of_theClickedElement;

		$("."+class_of_theElementToBeMoved).css({"left":left_of_theElementToBeMoved+"px", "top":top_of_theElementToBeMoved+"px"}).fadeIn();


	};
